import {
  DOCUMENT_REQUEST_STATUS,
  DocumentRequest,
  REQUEST_SORT_COLUMN,
  REQUEST_USE_CASE,
} from '@trustero/trustero-api-web/lib/request/request_pb'
import { GridColumnSortRequests } from 'src/components/Reusable/Grid/GridColumnSort/GridColumnSort.constants'

export enum DocumentRequestStatusLabels {
  OPEN = 'Open',
  READY = 'Ready',
  ACCEPTED = 'Accepted',
  RETURNED = 'Returned',
  COMPLETED = 'Completed',
}

export const DOCUMENT_REQUEST_STATUS_TO_LABEL: Record<number, string> = {
  [DOCUMENT_REQUEST_STATUS.OPEN]: DocumentRequestStatusLabels.OPEN,
  [DOCUMENT_REQUEST_STATUS.READY]: DocumentRequestStatusLabels.READY,
  [DOCUMENT_REQUEST_STATUS.ACCEPTED]: DocumentRequestStatusLabels.ACCEPTED,
  [DOCUMENT_REQUEST_STATUS.RETURNED]: DocumentRequestStatusLabels.RETURNED,
  [DOCUMENT_REQUEST_STATUS.COMPLETED]: DocumentRequestStatusLabels.COMPLETED,
}

export const DOCUMENT_REQUEST_LABEL_TO_STATUS: Record<
  DocumentRequestStatusLabels,
  DOCUMENT_REQUEST_STATUS
> = {
  [DocumentRequestStatusLabels.OPEN]: DOCUMENT_REQUEST_STATUS.OPEN,
  [DocumentRequestStatusLabels.READY]: DOCUMENT_REQUEST_STATUS.READY,
  [DocumentRequestStatusLabels.ACCEPTED]: DOCUMENT_REQUEST_STATUS.ACCEPTED,
  [DocumentRequestStatusLabels.RETURNED]: DOCUMENT_REQUEST_STATUS.RETURNED,
  [DocumentRequestStatusLabels.COMPLETED]: DOCUMENT_REQUEST_STATUS.COMPLETED,
}
export const REQUEST_STATUS_FILTER = [
  {
    value: DocumentRequestStatusLabels.OPEN,
    label: DocumentRequestStatusLabels.OPEN,
  },
  {
    value: DocumentRequestStatusLabels.READY,
    label: DocumentRequestStatusLabels.READY,
  },
  {
    value: DocumentRequestStatusLabels.ACCEPTED,
    label: DocumentRequestStatusLabels.ACCEPTED,
  },
  {
    value: DocumentRequestStatusLabels.RETURNED,
    label: DocumentRequestStatusLabels.RETURNED,
  },
  {
    value: DocumentRequestStatusLabels.COMPLETED,
    label: DocumentRequestStatusLabels.COMPLETED,
  },
]

export enum RequestUseCaseLabels {
  USE_CASE_UNSPECIFIED = 'All Types',
  REQUEST_FOR_EVIDENCE = 'Request for Evidence',
  REQUEST_FOR_POLICY_DOCUMENT = 'Request for Policy Document',
  REQUEST_FOR_VENDOR_ATTESTATION = 'Request for Vendor Attestation',
  REQUEST_FOR_INFORMATION = 'Request for Information',
  REQUEST_FOR_ACTION = 'Request for Action',
}

// Used for displaying a request's type in grid rows and show pages.
// USE_CASE_UNSPECIFIED resolves to empty string so unset rows show nothing.
export const REQUEST_USE_CASE_TO_LABEL: Record<number, string> = {
  [REQUEST_USE_CASE.USE_CASE_UNSPECIFIED]: '',
  [REQUEST_USE_CASE.REQUEST_FOR_EVIDENCE]:
    RequestUseCaseLabels.REQUEST_FOR_EVIDENCE,
  [REQUEST_USE_CASE.REQUEST_FOR_POLICY_DOCUMENT]:
    RequestUseCaseLabels.REQUEST_FOR_POLICY_DOCUMENT,
  [REQUEST_USE_CASE.REQUEST_FOR_VENDOR_ATTESTATION]:
    RequestUseCaseLabels.REQUEST_FOR_VENDOR_ATTESTATION,
  [REQUEST_USE_CASE.REQUEST_FOR_INFORMATION]:
    RequestUseCaseLabels.REQUEST_FOR_INFORMATION,
  [REQUEST_USE_CASE.REQUEST_FOR_ACTION]:
    RequestUseCaseLabels.REQUEST_FOR_ACTION,
}

// Used for filter dropdowns — includes "All Types" as the unset/show-all option.
export const REQUEST_USE_CASE_FILTER_LABEL: Record<number, string> = {
  [REQUEST_USE_CASE.USE_CASE_UNSPECIFIED]:
    RequestUseCaseLabels.USE_CASE_UNSPECIFIED,
  [REQUEST_USE_CASE.REQUEST_FOR_EVIDENCE]:
    RequestUseCaseLabels.REQUEST_FOR_EVIDENCE,
  [REQUEST_USE_CASE.REQUEST_FOR_POLICY_DOCUMENT]:
    RequestUseCaseLabels.REQUEST_FOR_POLICY_DOCUMENT,
  [REQUEST_USE_CASE.REQUEST_FOR_VENDOR_ATTESTATION]:
    RequestUseCaseLabels.REQUEST_FOR_VENDOR_ATTESTATION,
  [REQUEST_USE_CASE.REQUEST_FOR_INFORMATION]:
    RequestUseCaseLabels.REQUEST_FOR_INFORMATION,
  [REQUEST_USE_CASE.REQUEST_FOR_ACTION]:
    RequestUseCaseLabels.REQUEST_FOR_ACTION,
}

export const USE_CASE_SLUG: Record<number, string> = {
  [REQUEST_USE_CASE.REQUEST_FOR_EVIDENCE]: 'rfe',
  [REQUEST_USE_CASE.REQUEST_FOR_POLICY_DOCUMENT]: 'rfp',
  [REQUEST_USE_CASE.REQUEST_FOR_VENDOR_ATTESTATION]: 'rfva',
  [REQUEST_USE_CASE.REQUEST_FOR_INFORMATION]: 'rfi',
  [REQUEST_USE_CASE.REQUEST_FOR_ACTION]: 'rfa',
}

export const REQUEST_OBJECT_TYPE_LABEL: Record<string, string> = {
  controls: 'Controls',
  evidence: 'Evidence',
  policy: 'Policy',
  vendor: 'Vendor',
  risk: 'Risk',
}

export const REQUEST_OBJECT_IDS: Record<
  string,
  (r: DocumentRequest) => string[]
> = {
  controls: (r) => r.getControlIdsList(),
  evidence: (r) => r.getEvidenceIdsList(),
  policy: (r) => r.getPolicyModelIdsList(),
  vendor: (r) => r.getVendorIdsList(),
  risk: (r) => r.getRiskIdsList(),
}

export const REQUEST_SORT_COLUMNS = Object.freeze({
  [GridColumnSortRequests.EVIDENCE]: REQUEST_SORT_COLUMN.EVIDENCE,
  [GridColumnSortRequests.CONTROLS]: REQUEST_SORT_COLUMN.CONTROLS,
})
